// constants
import { showSuccessAlert } from "../../constants/alerts";
import { LocationsActionTypes } from "./constants";

const INIT_STATE = {
  locations: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface LocationActionType {
  type:
    | LocationsActionTypes.API_RESPONSE_SUCCESS
    | LocationsActionTypes.API_RESPONSE_ERROR
    | LocationsActionTypes.GET_LOCATIONS
    | LocationsActionTypes.ADD_LOCATIONS
    | LocationsActionTypes.DELETE_LOCATIONS
    | LocationsActionTypes.UPDATE_LOCATIONS
    | LocationsActionTypes.CLEAR_ERROR;

  payload: any;
}

const Locations = (state: any = INIT_STATE, action: LocationActionType): any => {
  switch (action.type) {
    case LocationsActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case LocationsActionTypes.GET_LOCATIONS: {
          return {
            ...state,
            locations: action.payload.data.data?.data,
            pagination: action.payload.data.data?.pagination || null,
            loading: false,
            initialLoading: false,
            error: null,
          };
        }

        case LocationsActionTypes.ADD_LOCATIONS:
        case LocationsActionTypes.UPDATE_LOCATIONS:
        case LocationsActionTypes.DELETE_LOCATIONS:
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };

        default:
          return { ...state };
      }

    case LocationsActionTypes.API_RESPONSE_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
        initialLoading: false,
      };

    case LocationsActionTypes.GET_LOCATIONS:
    case LocationsActionTypes.ADD_LOCATIONS:
    case LocationsActionTypes.UPDATE_LOCATIONS:
    case LocationsActionTypes.DELETE_LOCATIONS:
      return { ...state, loading: true, initialLoading: true };

    case LocationsActionTypes.CLEAR_ERROR:
      return { ...state, error: null };

    default:
      return { ...state };
  }
};

export default Locations;
